<template>
  <div class="select-startstop">
    <section class="title-bar">
      <div class="hero-body">
        <p class="title">作業の開始/終了</p>
        <p class="subtitle">作業の「開始」か「終了」を選択してください</p>
      </div>
    </section>

    <div class="block my-6"></div>

    <div class="tile is-ancestor">
      <div class="tile">
        <div class="tile"></div>
        <div v-on:click="start_clicked()" class="tile mx-6 is-parent">
          <b-button type="is-success" rounded expanded size="is-large"> 開始 </b-button>
        </div>
        <div v-on:click="stop_clicked()" class="tile mx-6 is-parent">
          <b-button type="is-success" rounded expanded size="is-large"> 終了 </b-button>
        </div>
        <div class="tile"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectStartStop',
  date() {
    return {
      uid: '',
    };
  },
  mounted() {
    if (!this.$route.query.uid || this.$route.query.uid === '') {
      this.$buefy.dialog.alert({
        message: '不正な遷移です。最初からやり直してください。',
        onConfirm: () => {
          this.$router.push('/login');
        },
      });
    }
    this.uid = this.$route.query.uid;
  },
  methods: {
    start_clicked: function () {
      this.$router.push('/select-place?action=start&uid=' + this.uid);
    },
    stop_clicked: function () {
      this.$router.push('/select-place?action=end&uid=' + this.uid);
    },
  },
};
</script>
<style scoped>
section.title-bar {
  background-color: #008a75;
}
p.title {
  color: white;
}
p.subtitle {
  color: white;
}

button.button.is-large.is-success.is-rounded.is-fullwidth {
  background-color: #ff7d00;
}
</style>


// WEBPACK FOOTER //
// src/components/SelectStartStop.vue